import { render } from "./ProjectTabs.vue?vue&type=template&id=f1f8b538"
import script from "./ProjectTabs.vue?vue&type=script&lang=js"
export * from "./ProjectTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__